export { ActivitiesNotificationComponent } from '@shared/layout/header/activities/activities-notification/activities-notification.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-notification/index.ts